import React from 'react';
import styled from 'styled-components';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import MobileApp from './components/MobileApp';
import Footer from './components/Footer';

const AppContainer = styled.div`
  min-height: 100vh;
  overflow-x: hidden;
`;

function App() {
  return (
    <AppContainer>
      <Navbar />
      <Hero />
      <About />
      <MobileApp />
      <Footer />
    </AppContainer>
  );
}

export default App;
